import { render, staticRenderFns } from "./ClaimTable.vue?vue&type=template&id=3e9ad2b9&"
import script from "./ClaimTable.vue?vue&type=script&lang=js&"
export * from "./ClaimTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports